import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {FormGroupComponent} from '../../../components/form-inputs/form-group/form-group.component';
import {UserSessionService} from '../../../services/user-session.service';
import {FormErrorService} from '../../../services/form-error.service';

@Component({
  selector: 'app-auth-two-factor-enable',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    FormGroupComponent
  ],
  templateUrl: './enable.component.html'
})
export class EnableComponent {
  public state: 'enabling' | 'confirming' = 'enabling';


  public form = new FormGroup({
    code: new FormControl<string>('', [Validators.required]),
  });

  public qrCode?: SafeHtml;

  public constructor(
    private cdr: ChangeDetectorRef,
    private userSessionService: UserSessionService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private formErrorService: FormErrorService,
  ) {}

  public enable() {
    this.userSessionService.enableTwoFactorAuth()
      .subscribe({
        next: res => {
          this.qrCode = this.sanitizer.bypassSecurityTrustHtml(res.svg);

          this.state = 'confirming';
          this.cdr.markForCheck();
        },
      });
  }

  public confirm() {
    this.form.markAllAsTouched();
    this.form.markAllAsDirty();

    const code = this.form.controls.code.value;
    if (code) {
      this.userSessionService.confirmTwoFactorAuth(code).subscribe({
        next: () => this.router.navigate(['']).then(),
        error: response => this.formErrorService.mapErrorToForm(this.form, response),
      })
    }
  }
}
